"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../schema");
const waitingListStartDate = schema_1.Schema.string()
    .date()
    .interpretation({ vocab: "ltx", code: "waiting_list_start_date" });
const patientEtId = schema_1.Schema.string()
    .optional()
    .pattern("^\\d{6}$")
    .interpretation({ vocab: "ltx", code: "patient_et_id" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ waitingListStartDate, patientEtId });
